export const environment = {
  production: false,
  env: 'dev' as const,
  appUrl: 'https://dev.videokestar.com',
  apiUrl: 'https://api-dev.videokestar.com/graphql',
  wsUrl: 'wss://api-dev.videokestar.com/graphql',
  googleClientId: '1019156695866-a2nesibgq0jt509sf7sfovnhq3eakhnq.apps.googleusercontent.com',
};
